import styled from 'styled-components';



export const Legend = styled.p`
  color: rgb(0, 14, 38);
  font-size: 1rem;
  line-height: 120%;
  letter-spacing: calc(-0.02em + 0.02rem);
  margin: 0px;
  padding: 0px;
  visibility: initial;
  display: inline-block;
`;
export const StdRequired = styled.span`
  &::after{
  content: '*';
  position: absolute;
  padding-left: 2px !important;
  color: rgb(0, 30, 80) !important;
  margin-top: -2px;
  }
`;


export const BoxError = styled.div`
  display: flex;
  flex-direction: row;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding-top: 4px;
  color: rgb(106, 118, 125);
  gap: 8px;
`;
export const Error = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(228, 0, 44);
  color: rgb(255, 255, 255);
  padding: 0px 4px;
  border-radius: 4px;
  min-height: 24px;
  min-width: 24px;
  margin-bottom: 10px;
  .err {
    color: rgb(255, 255, 255);
    margin: -0.11em 0px 0.11em;
    font-family: var(--font-family-text, vw-text, Helvetica, Arial, sans-serif);
    font-weight: normal;
    font-size: var(--textappearances-copy100-fontsize);
    line-height: var(--textappearances-copy100-lineheight);
    letter-spacing: var(--textappearances-copy100-letterspacing);
  }
`;

